import { UPDATE_FIRST_RUN,REFRESH_THEMES_SECTION } from "../reducers/keys";


export function updateFirstRun(isFirstRun){
    return {type:UPDATE_FIRST_RUN,payload:isFirstRun};
}

export const refreshThemes = () => {
    return { type: REFRESH_THEMES_SECTION}
}